let LAST_CART_TOTAL_PRICE = null; // in cents
let LAST_CART_ORIGINAL_TOTAL_PRICE = null; // (for strikethrough changes)

function updateCartIconCount(itemCount) {
  const count = Number(itemCount) || 0;

  const $badge = $("#CartButton .cart-count-js");
  $badge.text(count);

  if (count > 0) {
    $badge.show().css("display", "");
  } else {
    $badge.hide();
  }
}

function updateTotalsIfChanged(cart) {
  const total = Number(cart.total_price) || 0;
  const original = Number(cart.original_total_price) || 0;

  const totalChanged =
    LAST_CART_TOTAL_PRICE === null || total !== LAST_CART_TOTAL_PRICE;
  const originalChanged =
    LAST_CART_ORIGINAL_TOTAL_PRICE === null ||
    original !== LAST_CART_ORIGINAL_TOTAL_PRICE;

  if (!totalChanged && !originalChanged) return;

  LAST_CART_TOTAL_PRICE = total;
  LAST_CART_ORIGINAL_TOTAL_PRICE = original;

  // subtotal text
  $(".subtotal-price").text(
    slate.Currency.formatMoney(total, theme.moneyFormat)
  );

  // strikethrough logic
  const cartHasDiscounts = original > total;
  if (cartHasDiscounts) {
    $(".subtotal-price-strikethrough")
      .text(slate.Currency.formatMoney(original, theme.moneyFormat))
      .show();
  } else {
    $(".subtotal-price-strikethrough").hide();
  }

  // Alma update ONLY when changed
  if (ENABLE_ALMA_WIDGET_UPDATES) {
    updateAlmaWidgets(total);
  } else {
    skipAlmaWidgetUpdate(total);
  }
}

const defaults = {
  cartDrawer: ".js-ajax-cart-drawer", // classname
  cartDrawerContent: ".js-ajax-cart-drawer-content", // classname
  removeFromCart: ".js-ajax-remove-from-cart", //classname
};

const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);

function updateCartTitleCount(itemCount) {
  // Ensure itemCount is a valid number, default to 0 if NaN or invalid
  var count = isNaN(itemCount) || itemCount == null ? 0 : parseInt(itemCount);
  $(".cart-title-count").text(count);
}

function getCartLang() {
  if (typeof window.Weglot !== "undefined" && window.Weglot.getCurrentLang) {
    return window.Weglot.getCurrentLang();
  }
  if (window.Shopify && window.Shopify.locale) {
    return String(window.Shopify.locale).split("-")[0];
  }
  return "fr";
}

function getAjaxCartSectionUrl() {
  var root =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) ||
    "/";
  return root + (root.indexOf("?") >= 0 ? "&" : "?") + "section_id=ajax-cart";
}

var CART_OPTION_I18N = {
  en: {
    size: "Size",
    gold_colour: "Gold colour",
    engraving: "Personalised engraving",
    case_colour: "Case colour",
    rose_gold: "Rose gold",
    yellow_gold: "Yellow gold",
    white_gold: "White gold",
    with: "With",
    without: "Without",
    noir: "Black",
    blanc: "White",
    rose: "Pink",
    ivoire: "Ivory",
    jaune: "Yellow",
    bordeaux: "Burgundy",
    bleu: "Blue",
    rouge: "Red",
    vert: "Green",
    gris: "Grey",
    beige: "Beige",
    mauve: "Mauve",
    nude: "Nude",
    champagne: "Champagne",
    taupe: "Taupe",
    creme: "Cream",
  },
  fr: {
    size: "Taille",
    gold_colour: "Couleur d'or",
    engraving: "Gravure personnalisée",
    case_colour: "Couleur d′écrin",
    rose_gold: "Or rose",
    yellow_gold: "Or jaune",
    white_gold: "Or blanc",
    with: "Avec",
    without: "Sans",
    noir: "Noir",
    blanc: "Blanc",
    rose: "Rose",
    ivoire: "Ivoire",
    jaune: "Jaune",
    bordeaux: "Bordeaux",
    bleu: "Bleu",
    rouge: "Rouge",
    vert: "Vert",
    gris: "Gris",
    beige: "Beige",
    mauve: "Mauve",
    nude: "Nude",
    champagne: "Champagne",
    taupe: "Taupe",
    creme: "Crème",
  },
};

function translateCartOptionName(name, lang) {
  var key = String(name || "")
    .toLowerCase()
    .replace(/:$/, "")
    .trim();
  var dict = CART_OPTION_I18N[lang] || CART_OPTION_I18N.fr;

  if (key.indexOf("taille") >= 0 || key === "size") return dict.size;
  if (key.indexOf("gravure") >= 0 || key.indexOf("engrav") >= 0)
    return dict.engraving;
  if (
    key.indexOf("écrin") >= 0 ||
    key.indexOf("ecrin") >= 0 ||
    key.indexOf("case") >= 0
  )
    return dict.case_colour;
  if (
    (key.indexOf("or") >= 0 && key.indexOf("couleur") >= 0) ||
    (key.indexOf("gold") >= 0 &&
      (key.indexOf("colour") >= 0 || key.indexOf("color") >= 0)) ||
    key.indexOf("metal") >= 0
  )
    return dict.gold_colour;

  return String(name || "").replace(/:$/, "").trim();
}

function translateCartOptionValue(value, lang) {
  var raw = String(value || "").trim();
  if (!raw) return raw;

  var key = raw.toLowerCase();
  var dict = CART_OPTION_I18N[lang] || CART_OPTION_I18N.fr;

  // "Avec (+35€)" / "With (+$40)" — keep price suffix
  var withMatch = raw.match(/^(avec|with)\b(.*)$/i);
  if (withMatch) return dict.with + withMatch[2];

  var withoutMatch = raw.match(/^(sans|without)\b(.*)$/i);
  if (withoutMatch) return dict.without + withoutMatch[2];

  if (key.indexOf("or rose") >= 0 || key.indexOf("rose gold") >= 0)
    return dict.rose_gold;
  if (key.indexOf("or jaune") >= 0 || key.indexOf("yellow gold") >= 0)
    return dict.yellow_gold;
  if (key.indexOf("or blanc") >= 0 || key.indexOf("white gold") >= 0)
    return dict.white_gold;

  var colourMap = {
    noir: "noir",
    black: "noir",
    blanc: "blanc",
    white: "blanc",
    rose: "rose",
    pink: "rose",
    ivoire: "ivoire",
    ivory: "ivoire",
    jaune: "jaune",
    yellow: "jaune",
    bordeaux: "bordeaux",
    burgundy: "bordeaux",
    bleu: "bleu",
    blue: "bleu",
    rouge: "rouge",
    red: "rouge",
    vert: "vert",
    green: "vert",
    gris: "gris",
    grey: "gris",
    gray: "gris",
    beige: "beige",
    mauve: "mauve",
    nude: "nude",
    champagne: "champagne",
    taupe: "taupe",
    creme: "creme",
    "crème": "creme",
    cream: "creme",
  };
  if (colourMap[key]) return dict[colourMap[key]];

  return raw;
}

function translateCartDrawerOptions(root) {
  var lang = getCartLang();
  var scope = root || document;

  $(scope)
    .find(".product-size-wrap")
    .each(function () {
      var $label = $(this).find(".size-label");
      var $value = $(this).find(".size-value");
      if ($label.length) {
        var labelText = $label.text().replace(/:\s*$/, "").trim();
        $label.text(translateCartOptionName(labelText, lang) + ": ");
      }
      if ($value.length) {
        $value.text(translateCartOptionValue($value.text(), lang));
      }
    });
}

function fetchCart() {
  var emptyCartText =
    (window.theme && window.theme.strings && window.theme.strings.cartEmpty) ||
    "The cart is empty";

  // Fetch cart data for total price
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      // Update cart title count
      updateCartTitleCount(cart.item_count);
      updateCartIconCount(cart.item_count);

      if (cart.item_count === 0) {
        $(".side-cart-main-wrap").addClass("empty");
        cartDrawerContent.innerHTML =
          '<div class="empty_cart">' + emptyCartText + "</div>";
      } else {
        $(".side-cart-main-wrap").removeClass("empty");

        // Fetch fresh cart HTML from server (includes updated discounts)
        $.ajax({
          type: "GET",
          url: getAjaxCartSectionUrl(),
          success: function (html) {
            cartDrawerContent.innerHTML = html;
            translateCartDrawerOptions(cartDrawerContent);
            updateTotalsIfChanged(cart);
          },
        });
      }
    },
  });
}

function changeItem(line, qty) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + qty + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      fetchCart();
    },
  });
}

function addToCartFail() {
  cartModalContent.innerHTML =
    "The product you are trying to add is out of stock.";
  openAddModal();
  openCartOverlay();
}

function renderCart(cart) {
  //console.log(cart);
  clearCartDrawer();

  // Update cart title count
  updateCartTitleCount(cart.item_count);

  cart.items.forEach(function (item, index) {
    console.log(item);
    var removeText =
      (window.theme && window.theme.strings && window.theme.strings.cartRemove) ||
      "Remove";

    var productImage =
      '<div class="side-cart-product-img"><img src="' +
      item.image +
      '" alt="Product image"/></div>';
    var productTitle =
      '<div class="side-cart-product-content"><div class="side-cart-tps-wrap"><a href="' +
      item.url +
      '" class="product-title">' +
      (item.product_title || item.title) +
      "</a>";
    var productPrice =
      '<p class="product-price">' +
      slate.Currency.formatMoney(item.line_price, theme.moneyFormat) +
      "</p>";

    var lang = getCartLang();
    var productProp = "";
    $.each(item.options_with_values, function (key, value) {
      if (value["name"] != "Title") {
        productProp +=
          '<div class="product-size-wrap"><span class="size-label">' +
          translateCartOptionName(value["name"], lang) +
          ': </span><span class="size-value">' +
          translateCartOptionValue(value["value"], lang) +
          "</span></div>";
      }
    });

    var itemProperties = item.properties;

    if (itemProperties) {
      propertiesData = Object.keys(itemProperties);

      for (var i = 0; i < propertiesData.length; i++) {
        var key = propertiesData[i];
        var value = itemProperties[key];
        if (!key || key.charAt(0) === "_" || value == null || value === "") {
          continue;
        }
        productProp +=
          '<div class="product-size-wrap"><span class="size-label">' +
          translateCartOptionName(key, lang) +
          ': </span><span class="size-value">' +
          translateCartOptionValue(value, lang) +
          "</span></div>";
      }
    }

    productProp += "</div>";

    //const productQty = '<div class="side-cart-item__quantity"><span class="visually-hidden" data-cart-popup-quantity-label="">Quantité&nbsp;: 1</span>';
    var productQty =
      '<div class="side-cart-item__quantity"><div class="cart-quantity qtydiv qtybox">';
    productQty +=
      '<input type="button" data-line="' +
      Number(index + 1) +
      '" value="-" class="btnqty qtyminus icon icon-minus" field="updates_plus_minus">';
    productQty +=
      '<input type="text" name="quantity" value="' +
      item.quantity +
      '" min="1" class="quantity-selector quantity quantity-input" readonly="">';
    productQty +=
      '<input type="button" data-line="' +
      Number(index + 1) +
      '" value="+" class="btnqty qtyplus icon icon-plus" field="updates_plus_minus">';
    productQty += "</div></div>";
    var productRemove =
      '<a href="javascript:void(0)" role="button" data-line="' +
      Number(index + 1) +
      '" class="remove-link"> ' +
      ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.06934 6.75H17.9307C18.0753 6.75 18.1903 6.87232 18.1807 7.0166L17.3135 20.0166C17.3047 20.1479 17.1961 20.25 17.0645 20.25H6.93555C6.80393 20.25 6.69528 20.1479 6.68652 20.0166L5.81934 7.0166C5.80974 6.87232 5.92473 6.75 6.06934 6.75Z" fill="white" stroke="currentColor" stroke-width="1.5"/>
              <path d="M15 7V5C15 4.44772 14.5523 4 14 4H10C9.44772 4 9 4.44772 9 5V7" stroke="currentColor" stroke-width="1.5"/>
            </svg>` +
      "</a></div>";
    var concatProductInfo =
      '<div class="side-cart-item ajax-cart-item__single" data-line="' +
      Number(index + 1) +
      '">' +
      productImage +
      productTitle +
      productPrice +
      productProp +
      productQty +
      productRemove +
      "</div>";
    cartDrawerContent.innerHTML =
      cartDrawerContent.innerHTML + concatProductInfo;
  });

  // $(".subtotal-price").text(
  //   slate.Currency.formatMoney(cart.total_price, theme.moneyFormat)
  // );

  // // Handle strikethrough price if cart has discounts
  // var cartOriginalPrice = cart.original_total_price;
  // var cartHasDiscounts = cartOriginalPrice > cart.total_price;

  // if (cartHasDiscounts) {
  //   $(".subtotal-price-strikethrough")
  //     .text(slate.Currency.formatMoney(cartOriginalPrice, theme.moneyFormat))
  //     .show();
  // } else {
  //   $(".subtotal-price-strikethrough").hide();
  // }

  // // Update Alma widgets with new cart total
  // if (ENABLE_ALMA_WIDGET_UPDATES) {
  //   updateAlmaWidgets(cart.total_price);
  // } else {
  //   skipAlmaWidgetUpdate(cart.total_price);
  // }
  updateTotalsIfChanged(cart);
}

function openCartDrawer() {
  //cartDrawer.classList.add('is-open');
  $(".side-cart-main-wrap").toggleClass("open-side-cart");
  $(".side-cart-main-wrap").parent().toggleClass("open-side-cart");
  $("body").toggleClass("open-side-cart");
}

var invoke_make_blank = true;
function myFunction() {
  if (screen.width < 741) {
    if (invoke_make_blank) {
      $(".side-cart-main-wrap").toggleClass("open-side-cart");
      $(".side-cart-main-wrap").parent().toggleClass("open-side-cart");
      $("body").toggleClass("open-side-cart");
      document.getElementById("atcde").click();
      document.getElementById("sendtofriend").click();
      invoke_make_blank = false;
    } else {
      document.getElementById("SideCart").click();
    }
  } else {
    if (invoke_make_blank) {
      document.getElementById("atcde").click();
      invoke_make_blank = false;
      document.getElementById("SideCart").click();
    } else {
      document.getElementById("SideCart").click();
    }
  }
}

function closeCartDrawer() {
  //cartDrawer.classList.remove('is-open');
  if (
    $(event.target).hasClass("side-cart-overly-wrap") ||
    $(event.target).hasClass("close-icon-wrap")
  ) {
    $(".open-side-cart").removeClass("open-side-cart");
  }
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = "";
}

function generateLink() {
  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  if (isMobile.any()) {
    var baseUri = window.location.origin + "/account/logout?return_url=/cart/";
  } else {
    var baseUri = window.location.origin + "/cart/";
  }

  var items = "";

  $.getJSON("/cart.js", function (cart) {
    //console.log(cart);

    $.each(cart.items, function (index, item) {
      //console.log(item);
      items += item.id + ":" + item.quantity + ",";
    });

    baseUri += items.replace(/,\s*$/, "");
    console.log(baseUri);

    var email = $("#sym_email").val();
    var firstname = $("#sym_firstname").val();
    var lastname = $("#sym_lastname").val();
    var address = $("#sym_address").val();
    var address_supp = $("#sym_address_supp").val();
    var city = $("#sym_city").val();
    var state = $("#sym_state").val();
    var country = $("#sym_country").val();
    var zip_code = $("#sym_zip_code").val();

    var add =
      address +
      "<br/>" +
      address_supp +
      "<br/>" +
      zip_code +
      "<br/><br/>" +
      city +
      ", " +
      state +
      "<br/>" +
      country;
    $(".shopping-name").text(firstname + " " + lastname);
    $(".shopping-email").text(email);
    $(".shopping-address").html(add);

    var href = "";

    href = href.concat("?checkout[email]=" + email);

    if (firstname != "") {
      href = href.concat(
        "&checkout[shipping_address][first_name]=" + firstname
      );
    }

    if (lastname != "") {
      href = href.concat("&checkout[shipping_address][last_name]=" + lastname);
    }

    if (address != "") {
      href = href.concat("&checkout[shipping_address][address1]=" + address);
    }

    if (address_supp != "") {
      href = href.concat(
        "&checkout[shipping_address][address2]=" + address_supp
      );
    }

    if (city != "") {
      href = href.concat("&checkout[shipping_address][city]=" + city);
    }

    if (state != "") {
      href = href.concat("&checkout[shipping_address][province]=" + state);
    }

    if (country != "") {
      href = href.concat("&checkout[shipping_address][country]=" + country);
    }

    if (zip_code != "" && Number.isInteger(Number(zip_code))) {
      href = href.concat("&checkout[shipping_address][zip]=" + zip_code);
    }

    href = href.concat("&checkout_share=true");

    var url = baseUri.concat(encodeURIComponent(href));

    $(".copy-link").attr("data-url", url);
    console.log(url);
    $("#share_link").val(url);

    /*var copyText = document.querySelector("#share_link");
            copyText.select();
            document.execCommand("copy");
              */
  });
}

$(document).ready(function () {
  fetchCart();
  // Remove item from cart
  $(document).on("click", ".remove-link", function () {
    var line = $(this).attr("data-line");
    var quantity = parseInt(
      $(this).parent(".side-cart-product-content").find(".quantity-input").val()
    );
    var prevCartQuantity =
      parseInt($("#CartButton .cart-count-js").text()) || 0;
    var newTotal = prevCartQuantity - quantity;

    if (isNaN(newTotal)) newTotal = 0;

    $("#CartButton .cart-count-js")
      .text(newTotal)
      .show()
      .addClass("pulse-cart-icon");
    setTimeout(function () {
      $("#CartButton .cart-count-js").removeClass("pulse-cart-icon");
    }, 800);
    if (newTotal === 0) {
      $("#CartButton .cart-count-js").css("display", "none");
    }
    changeItem(line, 0);

    $(".side-cart-item[data-line='" + line + "']").remove();
  });

  //Update Qty from Cart
  $(document).on("click", ".btnqty", function () {
    var line = $(this).attr("data-line");
    var qty = parseInt(
      $(this).parent(".cart-quantity").find(".quantity-input").val()
    );
    var prevCartQuantity =
      parseInt($("#CartButton .cart-count-js").text()) || 0;
    var newTotal = prevCartQuantity;
    if ($(this).hasClass("qtyplus")) {
      qty = qty + 1;
      newTotal += 1;
    }
    if ($(this).hasClass("qtyminus")) {
      qty = qty - 1;
      newTotal -= 1;
    }
    $(this).parent(".cart-quantity").find(".quantity-input").val(qty);

    $("#CartButton .cart-count-js")
      .text(newTotal)
      .show()
      .addClass("pulse-cart-icon");
    setTimeout(function () {
      $("#CartButton .cart-count-js").removeClass("pulse-cart-icon");
    }, 800);
    if (newTotal === 0) {
      $("#CartButton .cart-count-js").css("display", "none");
    }
    changeItem(line, qty);
  });

  $(document).on("click", ".copy-link", function () {
    var copyText = document.querySelector("#share_link");
    copyText.select();
    document.execCommand("copy");
  });

  // Share in EMail
  $(document).on("click", ".share_mail", function () {
    console.log("share mail");

    var url = $("#share_link").val();
    var email = $("#sym_email").val();
    var subject = "Ma sélection Héloïse" + " \uFF06 " + "Abélard";

    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    if (isMobile.any()) {
      var emailBody = url;
      var result = emailBody.link(url);
    } else {
      var result = url;
    }

    window.location =
      "mailto:" + email + "?subject=" + subject + "&body=" + result;
  });

  // Share on Whatsapp (Mobile Only)
  $(document).on("click", ".share_whatsapp", function () {
    console.log("share whatsapp");
    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    if (isMobile.any()) {
      var text = "Ma sélection Héloïse" + " \uFF06 " + "Abélard";
      var url = $("#share_link").val();
      var message = encodeURIComponent(text) + " - " + encodeURIComponent(url);
      var whatsapp_url = "whatsapp://send?text=" + message;
      window.location.href = whatsapp_url;
    } else {
      alert("Please share this article in mobile device");
    }
  });

  // Share on messenger (mobile Only)
  $(document).on("click", ".share_fb", function () {
    console.log("share fb");
    var url = $("#share_link").val();
    window.open(
      "fb-messenger://share?link=" +
        encodeURIComponent(url) +
        "&app_id=" +
        encodeURIComponent("321654981321")
    );
  });
});

// Flag to control Alma widget updates (set to false to disable updates and avoid React DOM conflicts)
var ENABLE_ALMA_WIDGET_UPDATES = true;

// Alma widget initialization - debug removed for production
$(document).ready(function () {
  // Add error handling for Alma widget initialization
  window.addEventListener("error", function (e) {
    if (e.message && e.message.includes("Cannot destructure property")) {
      console.warn("Destructuring error caught:", e.message);
      console.warn("This might be related to Alma widget initialization");
    }
  });

  // Add unhandled promise rejection handling
  window.addEventListener("unhandledrejection", function (e) {
    if (
      e.reason &&
      e.reason.message &&
      e.reason.message.includes("Cannot destructure property")
    ) {
      console.warn(
        "Unhandled promise rejection with destructuring error:",
        e.reason.message
      );
      e.preventDefault(); // Prevent the error from showing in console
    }
  });
});

// Alternative function that provides user feedback without updating widgets
function skipAlmaWidgetUpdate(cartTotal) {
  // Skipping Alma widget update to avoid React DOM conflicts

  // Show a subtle notification that payment options may need refresh
  const notification = document.createElement("div");
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #fa8d74;
    color: white;
    padding: 10px 15px;
    border-radius: 4px;
    font-size: 14px;
    z-index: 10000;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    opacity: 0;
    transition: opacity 0.3s ease;
  `;
  notification.textContent = "Payment options updated";
  document.body.appendChild(notification);

  // Fade in
  setTimeout(() => {
    notification.style.opacity = "1";
  }, 100);

  // Fade out and remove
  setTimeout(() => {
    notification.style.opacity = "0";
    setTimeout(() => {
      if (notification.parentNode) {
        try {
          notification.parentNode.removeChild(notification);
        } catch (e) {
          notification.style.display = "none";
        }
      }
    }, 300);
  }, 2000);
}

// Function to safely clear container without using removeChild
function safeClearContainer(container) {
  if (!container || !container.parentNode) return;

  try {
    // Instead of removing children, we'll hide them and let Alma handle the cleanup
    const children = Array.from(container.children);
    children.forEach((child) => {
      if (child) {
        // Hide the child element instead of removing it
        child.style.display = "none";
        child.style.visibility = "hidden";
        child.style.opacity = "0";
      }
    });

    // Clear the innerHTML after hiding children to avoid React conflicts
    setTimeout(() => {
      try {
        container.innerHTML = "";
      } catch (e) {
        console.warn("Could not clear container innerHTML:", e);
      }
    }, 50);
  } catch (error) {
    console.warn("Error clearing container:", error);
  }
}

// Function to update Alma widgets with new cart total using a safer approach
function updateAlmaWidgets(cartTotal) {
  // Ensure we have a valid cart total
  if (!cartTotal || cartTotal < 0) {
    console.warn("Invalid cart total for Alma widget update:", cartTotal);
    return;
  }

  // Check if Alma widgets are available
  if (typeof window.Alma !== "undefined" && window.Alma.Widgets) {
    try {
      // Dispatch custom event for cart updates with the actual cart total
      window.dispatchEvent(
        new CustomEvent("alma-cart-updated", {
          detail: {
            total: cartTotal,
            eligible: cartTotal >= 5000 && cartTotal <= 450000, // Check if within Alma limits
          },
        })
      );

      // Also clean up existing widgets to ensure fresh initialization
      // const frCartWidget = document.getElementById("alma-widget-cart-fr");
      // const enCartWidget = document.getElementById("alma-widget-cart-en");

      // if (frCartWidget && frCartWidget.hasAttribute("data-alma-initialized")) {
      //   // Remove the initialized flag to allow re-initialization
      //   frCartWidget.removeAttribute("data-alma-initialized");
      //   //frCartWidget.innerHTML = "";
      // }

      // if (enCartWidget && enCartWidget.hasAttribute("data-alma-initialized")) {
      //   // Remove the initialized flag to allow re-initialization
      //   enCartWidget.removeAttribute("data-alma-initialized");
      //   //enCartWidget.innerHTML = "";
      // }
    } catch (error) {
      console.warn("Error updating Alma widgets:", error);
    }
  } else {
    console.warn("Alma widgets not available for cart update");
  }
}
